export default __webpack_public_path__ + "static/media/calendar-next.601baa72.svg";